import {ActionWithPayload} from '../../../helpers/reduxHelpers';
import {ThunkAction} from '../../appThunk';

/*
 * Action types.
 */

export enum TagsActionsEnum {
  TAG_DELETED = '@@data/tags/TAG_DELETED',
  TAG_DELETION_CONFIRMED = '@@data/tags/TAG_DELETION_CONFIRMED',
}

/*
 * Types.
 */

export interface TagDeletedAction extends ActionWithPayload<number> {
  type: TagsActionsEnum.TAG_DELETED;
}

export interface TagDeletedCompletedAction extends ActionWithPayload<number> {
  type: TagsActionsEnum.TAG_DELETION_CONFIRMED;
}

/*
 * Action creators.
 */

export function deleteTagAction(tagId: number): ThunkAction {
  return (dispatch, getState) => {
    // If we don't have this tag, nothing to do.
    const existingTag = getState().data.tags[tagId];
    if (!existingTag) {
      return null;
    }

    const action: TagDeletedAction = {
      type: TagsActionsEnum.TAG_DELETED,
      payload: tagId,
    };
    return dispatch(action);
  };
}

export function deleteTagConfirmedAction(tagId: number): TagDeletedCompletedAction {
  return {
    type: TagsActionsEnum.TAG_DELETION_CONFIRMED,
    payload: tagId,
  };
}

/*
 * Union type.
 */

export type TagsAction = TagDeletedAction | TagDeletedCompletedAction;
